import type { AiProvider, TokenAnalyticsByModel } from '@/types/analytics'

const PROVIDER_ORDER: AiProvider[] = ['Anthropic', 'GitHub', 'Titan']

export function pickDefaultProvider(usage: Partial<Record<AiProvider, TokenAnalyticsByModel>>): AiProvider {
  let best: AiProvider = 'Anthropic'

  for (const candidate of PROVIDER_ORDER) {
    const candidateUsage = usage[candidate]
    if (!candidateUsage) continue

    const bestCost = usage[best]?.totalCostUsd ?? 0
    const bestTokens = usage[best]?.totalTokens ?? 0

    const spendsMore = candidateUsage.totalCostUsd > bestCost
    const spendsEqualButUsesMoreTokens =
      candidateUsage.totalCostUsd === bestCost && candidateUsage.totalTokens > bestTokens

    if (spendsMore || spendsEqualButUsesMoreTokens) best = candidate
  }

  return best
}
